import { setSpecificMessage, notBytes } from "valibot";
setSpecificMessage(
  notBytes,
  (issue) => `Octet invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);